import { createFileRoute } from '@tanstack/react-router';
import { AdminFeedbackInboxScreen } from '@/features/admin/AdminFeedbackInboxScreen';
import { FEEDBACK_FILTERS, type FeedbackFilter } from '@/features/admin/feedbackLabels';
import { isSectionKey, type SectionKey } from '@/lib/access';

type Status = FeedbackFilter;
/** ?status=, ?page= and ?feature= (the early access section a thread was
 *  sent from, docs/ACCESS.md). */
type Search = { status?: Status; page?: number; feature?: SectionKey };

const STATUSES: Status[] = FEEDBACK_FILTERS;

export const Route = createFileRoute('/_app/admin/feedback/')({
  validateSearch: (s: Record<string, unknown>): Search => ({
    status: STATUSES.includes(s.status as Status) ? (s.status as Status) : undefined,
    page: typeof s.page === 'number' && s.page >= 1 ? Math.floor(s.page) : undefined,
    feature: isSectionKey(s.feature) ? s.feature : undefined,
  }),
  component: () => {
    const { status, page, feature } = Route.useSearch();
    return <AdminFeedbackInboxScreen status={status ?? null} page={page ?? 1} feature={feature ?? null} />;
  },
});
